// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".test-view[data-v-0b056497]{padding:42px}.section[data-v-0b056497]{margin-bottom:12px}", ""]);
// Exports
module.exports = exports;
